// extracted by mini-css-extract-plugin
module.exports = {"block":"_02712f2b3b--block--GQe5B"};